import { arrayDims as t } from "./array.js";

function r(t) {
  return t ? Array.isArray(t) ? [t[0], t[1]] : [t.lng, t.lat] : [];
}

function n(t) {
  return Array.isArray(t) ? [t[0], t[1]] : [t.x, t.y];
}

function a(t) {
  return Array.isArray(t) ? t : t.southWest ? [[t.southWest.lng, t.southWest.lat], [t.northEast.lng, t.northEast.lat]] : [[t.southwest.lng, t.southwest.lat], [t.northeast.lng, t.northeast.lat]];
}

function o(t) {
  var r = new window.AMap.LngLat(t[0][0], t[0][1]),
      n = new window.AMap.LngLat(t[1][0], t[1][1]);
  return new window.AMap.Bounds(r, n);
}

function e(n) {
  if (!Array.isArray(n)) return [];
  var a = t(n);
  return 1 === a.length || 2 === a.length ? n.map(r) : 3 === a.length ? n.map(function (t) {
    return t.map(r);
  }) : [];
}

export { o as array2Bounds, a as bounds2Array, r as lngLat2Array, e as path2Array, n as xy2Array };